import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=352cf3c0"
import script from "./ComingSoon.vue?vue&type=script&lang=ts"
export * from "./ComingSoon.vue?vue&type=script&lang=ts"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=352cf3c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports